module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-174173767-1","head":true,"anonymize":false,"respectDNT":false,"exclude":["/preview/**"]},
    },{
      plugin: require('../node_modules/gatsby-plugin-ts-config/gatsby-browser.js'),
      options: {"plugins":[],"configDir":"./config","babel":false,"tsNode":true},
    }]
